angular.module('app.doubleHorizontalScrollDirective', []).directive('doubleHorizontalScroll', [
  '$timeout',
  function($timeout) {
    return {
      restrict: 'A',

      scope: {
        controlledScroll: '@',
        verticalScrollContainer: '@',
        clipsBodyContainer: '@'
      },

      link: function($scope, iElm, iAttrs, controller) {
        iElm.scroll(function() {
          $($scope.controlledScroll).scrollLeft(iElm.scrollLeft());
        });

        $($scope.controlledScroll).scroll(function() {
          iElm.scrollLeft($($scope.controlledScroll).scrollLeft());
        });

        $timeout(() => {
          if(angular.isDefined($scope.verticalScrollContainer)) {
            let showScrollBar = $($scope.clipsBodyContainer).height() > $($scope.verticalScrollContainer).height();
            $($scope.verticalScrollContainer).css({
              'height': showScrollBar ? '700px' : 'auto',
              'margin-right': showScrollBar ? '-25px' : '0'
            });
          }
        }, 3000)

      }
    };
  }
]);


// WEBPACK FOOTER //
// ./app.v2/components/fhApp/doubleHorizontalScrollDirective.js